export default {
  title: 'Znajdź coś dla siebie!',
  description: 'Tutaj pojawią się Twoje zamówienia.',
  buttons: {
    order_now: 'Zamów teraz',
  },
};
